'use client';
import React from 'react';

export interface ChatbotSettings {
  chatflowid: string;
  apiHost: string;
}

export const ChatbotSettingsContext = React.createContext<ChatbotSettings | undefined>(undefined);

interface ChatbotSettingsProviderProps {
  settings?: ChatbotSettings;
  children: React.ReactNode;
}

export const ChatbotSettingsProvider = ({ settings, children }: ChatbotSettingsProviderProps) => (
  <ChatbotSettingsContext.Provider value={settings}>
    {children}
  </ChatbotSettingsContext.Provider>
);

export const useChatbotSettings = (): ChatbotSettings | undefined =>
  React.useContext(ChatbotSettingsContext);
